import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: {
    '&': tw`bg-green-200 text-green-600 font-bold rounded-lg`,
    '&:hover': tw`bg-green-300`,
    '&:focus': tw`bg-green-300`,
    height: 'auto',
  },
  label: {
    whiteSpace: 'normal',
    padding: '10px',
  },
}));
